import {redirect} from 'react-router';
import {apiClient} from '@common/http/query-client';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {resolveDefaultTimelineYear} from '@app/timeline/resolve-default-timeline-year';
import {TimelineMetadataResponse} from '@app/timeline/timeline-types';

export async function timelineIndexLoader() {
  const bootstrap = getBootstrapData().loaders?.timelinePage;

  if (bootstrap?.metadata) {
    return redirect(
      `/timeline/${resolveDefaultTimelineYear(bootstrap.metadata)}`,
    );
  }

  const metadata = await apiClient
    .get<TimelineMetadataResponse>('timeline')
    .then(response => response.data);

  return redirect(`/timeline/${resolveDefaultTimelineYear(metadata)}`);
}
